import React from "react";

const HeaderCompNew = ({ text, isDone, name, isSucess, showStartTrial }) => {
   return (
      <div>
         <div className="pg-header-title-new-ui">{text?.title}</div>
         {text?.para && (
            <div
               style={{ width: showStartTrial && "60%", margin: "auto" }}
               className={`${
                  isDone ? "ss-para-done-text" : "ss-para-text-new-ui"
               } pg-commen-title-para-text-new-ui pt-4 text-center`}
            >
               <div>{isSucess ? `Hi ${name}, ${text?.para}` : text?.para}</div>
            </div>
         )}
      </div>
   );
};

export default HeaderCompNew;
